import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { useApiSDK } from '../../contexts/apiSdkContext';
import { AppContext } from '../../pages/layout';

type TRevokeRefreshTokenHook = {
  isError: boolean;
  isLoading: boolean;
  mutate: UseMutationResult<void, unknown, string, unknown>['mutate'];
};

function useRevokeRefreshToken(): TRevokeRefreshTokenHook {
  const sdk = useApiSDK();
  const appContext = useContext(AppContext);
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { isError, isLoading, mutate } = useMutation({
    mutationFn: (id: string) => sdk.refreshTokens.revoke(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries(['refresh-tokens']);
      appContext?.crudAlert('delete', 'refresh token', 'm');
      navigate('/settings/refresh-tokens');
    },
    onError: async (error: any) => {
      if (error) {
        const responseErrors = error.response.data.errors;
        responseErrors.forEach((err: { message: string; description: string }) => {
          appContext?.systemAlert('error', err.description);
        });
      }
    },
  });

  return { isError, isLoading, mutate };
}

export { useRevokeRefreshToken };
